var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup--container b-radius--5 absolute flex flex--column overflowHidden",style:({ top: ((_vm.posY + 30) + "px"), left: ((_vm.posX - 250) + "px") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }